import SeleksiVendorApi from './SeleksiVendorApi'

export default SeleksiVendorApi